import React, { FC } from 'react'
import { CautionCard, LargeMenuCard, StockCardList } from 'components/Card'
import { Spacer } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getBreads } from 'reducks/bread/selectors'
import { getStocks } from 'reducks/stock/selectors'
import { getRole } from 'reducks/auth/selectors'
import { Role } from 'lib/role'

type Props = {
  isPast: boolean
}

const NoOrderSection: FC<Props> = React.memo(({ isPast }) => {
  const breads = useSelector((state: State) => getBreads(state))
  const stocks = useSelector((state: State) => getStocks(state))
  const role = useSelector((state: State) => getRole(state))
  const roleManager = new Role(role)

  if (isPast) {
    return <CautionCard caution={'お渡しが必要な注文はありません'} />
  } else if (stocks.length > 0) {
    // 受取番号が存在せず、在庫数が1以上の当日取り置き商品が存在する場合
    return (
      <>
        <CautionCard
          caution={'お渡しが必要な注文はありません'}
          description={'お客さまに取り置きできる商品があることを通知しませんか？'}
        />
        <Spacer size={12} />
        <StockCardList breads={breads} page={'released'} stocks={stocks} />
      </>
    )
  } else {
    // 受取番号が存在せず、在庫数が1以上の当日取り置き商品が存在しない場合（販売できる商品がない場合）
    return (
      <>
        <CautionCard
          caution={'お渡しが必要な注文はありません'}
          description={
            '現在商品の在庫が設定されていないため、お客さまが当日取り置きできる商品がありません。在庫を追加してお客さまが取り置きできるようにしてみませんか？'
          }
        />
        {roleManager.hasEnoughRole(9) && (
          <>
            <Spacer size={12} />
            <LargeMenuCard
              dataCy={'no-order-section'}
              description={
                '当日取り置きできる商品の在庫を増減したり、お客さまに商品が取り置きできる通知を送ることが出来ます。'
              }
              iconPath={'/icon/blue/stock.svg'}
              url={'/stock'}
              title={'在庫の増減と通知'}
            />
          </>
        )}
      </>
    )
  }
})

export default NoOrderSection
